/** Пустой список из-за незаполненных полей формы: что заполнить. */
const PickerDependenciesHint = ({ labels }: { labels: string[] }) => {
    const one = labels.length === 1;
    return (
        <>
            <b>
                Список зависит от {one ? 'поля' : 'полей'} {labels.map((label) => `«${label}»`).join(', ')}
            </b>
            {one ? 'Сначала заполните его.' : 'Сначала заполните их.'}
        </>
    );
};

export default PickerDependenciesHint;
